import React from 'react';
import QuerySampleCard from '../components/QuerySampleCard';
import QueryHelpPageLayout from '../QueryHelpPageLayout';
import {QUERY_HELP_PAGE_INTROS} from '../content/pages';
import {COMPLEX_SAMPLES} from '../content/complexSamples';

const ComplexSamplesPage = React.memo(() => (
    <QueryHelpPageLayout
        title="Complex samples"
        intro={QUERY_HELP_PAGE_INTROS.complex}
    >
        <div className="query-help-modal__sample-list">
            {COMPLEX_SAMPLES.map((item) => (
                <QuerySampleCard key={item.id} item={item} />
            ))}
        </div>
    </QueryHelpPageLayout>
));

export default ComplexSamplesPage;
